export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const MAKE_REQUEST = "MAKE_REQUEST";
export const FAIL_REQUEST = "FAIL_REQUEST";
export const PROFILE_REQUEST_SUCCESS = "PROFILE_REQUEST_SUCCESS";
export const SUCCESS_REQUEST = "SUCCESS_REQUEST";

export const ADD_PROFILE_STATE = "ADD_PROFILE_STATE";

export const LOADING_PERCENTAGE = "LOADING_PERCENTAGE";
export const UPLOAD_VIDEO_CLOUDINARY_SUCCESS =
  "UPLOAD_VIDEO_CLOUDINARY_SUCCESS";
export const RESET_LOADING_PERCENTAGE = "RESET_LOADING_PERCENTAGE";
